import Base from './Base';

/**
 * header
 */
export default class Header extends Base {
    /**
     * constructor
     */
    constructor() {
        super({
            el: '.js-header',
        });
    }

    /**
     * 高さを取得する
     *
     * @return {number}
     */
    get offsetHeight() {
        return this.$el.offsetHeight;
    }

    /**
     * 非表示にする
     */
    hide() {
        this.$el.style.display = 'none';
    }

    /**
     * 表示する
     */
    show() {
        this.$el.style.display = '';
    }
}
